import axios from 'axios';

const URL_API_BI = process.env.VUE_APP_URL_API_BI;

export class BiApiService {
  /**
   * Devuelve los almacenes disponibles
   * @return Hashmap[]
   */
  getAllAlmacen() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllAlmacen`;
    return axios
      .get(url,config)
      // .get(url,{
      //   auth: {
      //       username: 'admin',
      //       password: 'secret'
      //   }})
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTemporada() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTemporada`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllStockLibreByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllStockLibreByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllStockByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllStockByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /**
   * @param almacenid
   * @param temporadaid
   * Devuelve el movimiento pedido
   * @return Bimodel[]
   */
  getAllPedidoByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllPedidoByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /**
   * @param almacenid
   * @param temporadaid
   * Devuelve el movimiento albaran
   * @return Bimodel[]
   */
  getAllAlbaranByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllAlbaranByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /**
   * @param almacenid
   * @param temporadaid
   * Devuelve el movimiento reserva stock
   * @return Bimodel[]
   */
  getAllReservaStockByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllReservaStockByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /**
   * @param almacenid
   * @param temporadaid
   * Devuelve el movimiento reserva compra
   * @return Bimodel[]
   */
  getAllReservaCompraByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllReservaCompraByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /**
   * @param almacenid
   * @param temporadaid
   * Devuelve el movimiento odt
   * @return Bimodel[]
   */
  getAllOdtByAlmacenIdandTempId(almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllOdtByAlmacenIdandTempId/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorMovimientos() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorMovimientos`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorFamilias() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorFamilias`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorSubfamilias() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorSubfamilias`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorAlmacenes() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorAlmacenes`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getTop10Subfamilias() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getTop10Subfamilias`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  /*getAllTotalPorAlmacenByTipoMovimiento(tipo) {
    const url = `${URL_API_BI}getAllTotalPorAlmacenByTipoMovimiento/${tipo}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }*/
  
  getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(tipo,almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId/${tipo}/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(tipo,almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId/${tipo}/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(tipo,almacenid,temporadaid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId/${tipo}/${almacenid}/${temporadaid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllStockPorFamiliaByAlmacenId(almacenids) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllStockPorFamiliaByAlmacenId`;
    return axios
      .post(url, almacenids, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllStockPorSubfamiliaByAlmacenId(almacenids) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllStockPorSubfamiliaByAlmacenId`;
    return axios
      .post(url, almacenids, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getTop10StockPorArticuloByAlmacenId(almacenids) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getTop10StockPorArticuloByAlmacenId`;
    return axios
      .post(url, almacenids, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getPildoraByIdAndItemId(bipid, bipitemid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getPildoraByIdAndItemId/${bipid}/${bipitemid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getPildoraByIdAndItemIds(bipid, bipitemids) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getPildoraByIdAndItemIds/${bipid}/${bipitemids}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getPildorasConfig() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getPildorasConfig/`;
    return axios
      .get(url, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllPildoraByIdsAndItemId(idshm) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllPildoraByIdsAndItemId`;
    return axios
      .post(url, idshm, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getGraficoByIdsAndItemId(bigid, bigitemid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getGraficoByIdsAndItemId/${bigid}/${bigitemid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllGraficoByIdsAndItemId(idshm) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllGraficoByIdsAndItemId`;
    return axios
      .post(url, idshm, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllMejoresVentasOp(dirid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}getAllMejoresVentasOp/${dirid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  getAllMetavistaByDirIdAndId(dirid, idmetavista) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    // const url = `${URL_API_BI}getAllMetavista${idmetavista}ByDirId/${dirid}`;
    const url = `${URL_API_BI}getMetavista/${idmetavista}/${dirid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  saveLayout(layout) {
    let config = {
      headers: { 'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_BI}saveLayout`;
    const bodyParameters = {
      userId: localStorage.getItem("userId"),
      layout: layout
    };

    return axios
      .post(url, bodyParameters, config)
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  getLayout() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    let userId = localStorage.getItem("userId");
    const url = `${URL_API_BI}getLayout/${userId}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  getPildorasJson() {
    // var convert = require('xml-js');
    const url =`${process.env.BASE_URL}pildoras.json`;
    return axios
      .get(url)
      .then(function(response) {
         // Lo utilizamos si el archivo es un xml
         //return convert.xml2json(response.data, {compact: true, spaces: 4})
         return response.data
          
        })  
      .catch(function(error) {
        throw error;
      });     
  }
  getGraficosJson() {
    // var convert = require('xml-js');
    const url =`${process.env.BASE_URL}echarts.json`;
    return axios
      .get(url)
      .then(function(response) {
         // Lo utilizamos si el archivo es un xml
         //return convert.xml2json(response.data, {compact: true, spaces: 4})
         return response.data
          
        })  
      .catch(function(error) {
        throw error;
      });     
  }
  getMetavistasJson() {
    // var convert = require('xml-js');
    const url =`${process.env.BASE_URL}tablas.json`;
    return axios
      .get(url)
      .then(function(response) {
         // Lo utilizamos si el archivo es un xml
         //return convert.xml2json(response.data, {compact: true, spaces: 4})
         return response.data
          
        })  
      .catch(function(error) {
        throw error;
      });     
  }
}